import { render } from "./ChatAssistant.vue?vue&type=template&id=b0f9a33c&scoped=true"
import script from "./ChatAssistant.js?vue&type=script&lang=js&external"
export * from "./ChatAssistant.js?vue&type=script&lang=js&external"

import "./ChatAssistant.vue?vue&type=style&index=0&id=b0f9a33c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f9a33c"]])

export default __exports__